import { RouterView } from 'vue-router';
import { BaseAuthenticatedView, MunicipalitySelectView } from '@/views/authenticated';

import authRoutes from './auth';
import planRoutes from './plans';
import adminRoutes from './admin';

export default [
  {
    path: '/',
    component: BaseAuthenticatedView,
    meta: { requiresAuthentication: true },
    children: [
      {
        path: 'select-municipality',
        name: 'app_municipality_select',
        meta: { title: 'Select Municipality' },
        component: MunicipalitySelectView,
      },
      ...planRoutes,
      ...authRoutes,
      {
        path: '',
        component: RouterView, // wrapper
        meta: { requiresAdmin: true },
        children: adminRoutes,
      },
    ],
  },
];
